import { combineReducers } from "@reduxjs/toolkit";
import categoriesMaster from "./categoriesMaster";
import users from "./users";
import manufacturer from "./manufacturer";
import productCategory from "./productCategories";
import customer from "./customer";
import jobType from "./jobType";
import technicians from "./technicians";
import products from "./product";
import customerLocationList from "./customerLocation";
import customerDiscountList from "./customerDiscount";
import service from "./service";
import technicianAvailability from "./technicianAvailability";
import sparePart from "./sparePart";
import customerEquipmentList from "./customerEquipment";
import job from "./job";
import technicianLeave from "./technicianLeave";
import availableDates from "./availableTechnicianDates";
import quotation from "./quotation";
import requestSpareParts from "./requestSpareSparts";
import assignLocation from "./subUser";

export const reducers = combineReducers({
  categoriesMaster,
  users,
  manufacturer,
  productCategory,
  jobType,
  technicians,
  customer,
  products,
  customerLocationList,
  customerDiscountList,
  service,
  technicianAvailability,
  sparePart,
  customerEquipmentList,
  job,
  technicianLeave,
  availableDates,
  quotation,
  requestSpareParts,
  assignLocation,
});
